// 人物美颜
import addIndex from '@/views/edit/add/index'

const jyRoutes = Array.from({ length: 28 }, (_, i) => ({
  path: `add/jy/index${i + 1}`,
  name: `add/jy/Index${i + 1}`,
  component: () => import(`@/views/edit/add/jy/index${i + 1}.vue`)
}))
const xtRoutes = Array.from({ length: 30 }, (_, i) => ({
  path: `add/xt/index${i + 1}`,
  name: `add/xt/Index${i + 1}`,
  component: () => import(`@/views/edit/add/xt/index${i + 1}.vue`)
}))

export default {
  path: '/edit',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'add/index',
      name: 'addIndex',
      component: addIndex
    },
    // 人物美颜，开始
    ...jyRoutes,
    ...xtRoutes
    // 人物美颜，结束

  ]
}
